var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.$t('components.imgDialog.title'),"visible":_vm.imgShowVisible,"before-close":_vm.showClose,"append-to-body":true,"width":"50%","center":""},on:{"update:visible":function($event){_vm.imgShowVisible=$event}}},[_c('img',{attrs:{"width":"100%","height":"100%","src":_vm.imgUrlImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }